export const our_brands = [
  {
    "name-ar": "Name AR 1",
    "name-en": "Name En 1",
    "img-ar": "/imgs/category-1.png",
    "img-en": "/imgs/category-2.png",
    url: "/",
  },
  {
    "name-ar": "Name AR 2",
    "name-en": "Name En 2",
    "img-ar": "/imgs/category-3.png",
    "img-en": "/imgs/category-4.png",
    url: "/",
  },
  {
    "name-ar": "Name AR 3",
    "name-en": "Name En 3",
    "img-ar": "/imgs/category-5.png",
    "img-en": "/imgs/category-6.png",
    url: "/",
  },
  {
    "name-ar": "Name AR 4",
    "name-en": "Name En 4",
    "img-ar": "/imgs/category-1.png",
    "img-en": "/imgs/category-2.png",
    url: "/",
  },
  {
    "name-ar": "Name AR 5",
    "name-en": "Name En 5",
    "img-ar": "/imgs/category-3.png",
    "img-en": "/imgs/category-4.png",
    url: "/",
  },
];

export const sortKeys = [
  {
    key: "sortBy=position&sortDir=ASC",
    label: "Most Views",
  },
  {
    key: "sortBy=price&sortDir=ASC",
    label: "Price Low To High",
  },
  {
    key: "sortBy=price&sortDir=DESC",
    label: "Price High To Low",
  },
  // {
  // 	key: 'sortBy=created_at&sortDir=DESC',
  // 	label: 'latest',
  // },
];
